import { IpBlocksTable } from '@/components/features/ip-block'

export const IPBlocklist = () => {
  return <IpBlocksTable />
}
